import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Row, Col, Form } from "react-bootstrap";

const BookingChart = ({ bookingReport, weeklyBookings }) => {
  const [selectedOption, setSelectedOption] = useState("month");

  // Data for the chart based on the selected option
  const chartData =
    selectedOption === "month"
      ? bookingReport?.totalBookingsPerMonth
      : weeklyBookings;

  // Chart options
  const options = {
    chart: {
      id: "basic-bar",
      height: 350,
    },
    xaxis: {
      categories:
        selectedOption === "month"
          ? [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ]
          : ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6"], // Replace with actual weekly data labels
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        borderRadiusApplication: "end",
      },
    },
    colors: ["#bf0020"],
  };

  // Handle weekly data with totalCount field
  const series = [
    {
      name: "Bookings",
      data:
        selectedOption === "month"
          ? chartData?.map((i) => i) || [] // For monthly bookings
          : chartData?.map((i) => i?.totalCount) || [], // For weekly bookings
    },
  ];

  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };

  return (
    <Row className="justify-content-center">
      <Col lg="12">
        <div className="cardCstm p-3 rounded border">
          {/* <div className="cardHead m-0 pb-2 d-flex justify-content-between align-items-center">
            <h6 className="m-0 fw-sbold themeBlue">No. of Bookings</h6>
            
            <Form.Select value={selectedOption} onChange={handleChange} className="w-auto">
              <option value="month">Month</option>
              <option value="week">Week</option>
            </Form.Select>
          </div> */}
          <div className="graph">
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height={350}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default BookingChart;
